export const getProgress = (num) => {
  if (parseFloat(num) % 1 === 0) {
    return num;
  }
  try {
    return num.toFixed(1);
  } catch (e) {
    return 0;
  }
};
